import { E_RouterNames } from "@/router/types";

export interface IBuildAngleAlarmHistoryRouterParams {
    companyId: number
    areaId: number
    equipmentId: number
    mappingId?: number
    sensorId?: string
    createTime?: string
}

export function buildAngleAlarmHistoryRouter(params: IBuildAngleAlarmHistoryRouterParams) {
    return {
        name: E_RouterNames.AngleAlarmHistory,
        query: params
    }
}
